/* @flow */
import {
  CLEAR_CREATION_TEMPLATES,
  CREATION_CLEAR_SEARCH,
  CREATION_SEARCH_TEMPLATES,
  ERROR_CREATION_TEMPLATES,
  LOAD_MORE_CREATION_TEMPLATES,
  REQUEST_CREATION_TEMPLATES,
  NEW_PRODUCT_CREATION,
} from '../../../ActionsConst';
import type { Action } from '../../../ActionsConst';
import type { SearchAction } from '../actions/search/SearchActions';

type State = {
  isLoading: boolean,
  start: number,
  total: number,
  hasMore: boolean,
  templateSearch: string,
  isSingleProductType: boolean,
};

export type LoadAction = Action & {
  load: {
    isLoading: boolean,
    start?: number,
    total?: number,
    hasMore?: boolean,
  },
};

const initialState: State = {
  isLoading: false,
  start: 0,
  total: 0,
  hasMore: true,
  templateSearch: '',
  isSingleProductType: false,
};

// TODO: MB-3618 - CLEANUP - Templates actions to be moved to another reducer
const creationSettings = (state: State = initialState, action: LoadAction | SearchAction): State => {
  switch (action.type) {
    case CREATION_SEARCH_TEMPLATES:
      return { ...state, ...action.search };
    case CREATION_CLEAR_SEARCH:
      return { ...state, templateSearch: '' };
    case REQUEST_CREATION_TEMPLATES:
    case ERROR_CREATION_TEMPLATES:
    case NEW_PRODUCT_CREATION:
    case LOAD_MORE_CREATION_TEMPLATES:
      return { ...state, ...action.load };
    case CLEAR_CREATION_TEMPLATES:
      return { ...initialState };
    default:
      return state;
  }
};

export default creationSettings;
